<template>
  <AddStudent />
</template>
<script>
import appConfig from '@/app.config'
import AddStudent from '../../../components/skillup/students/AddStudent.vue'
export default {
  page: {
    title: 'اضافه کردن دانش پذیر',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'skillup-add-students',
  components: {
    AddStudent,
  },
}
</script>
